const CARD_IMAGES_DEV_KEY = "memberText";
const GOLD_CARD_REGULAR_KEY = "goldstarRegular";
const BUSINESS_CARD_KEY = "business";
const GOLD_STAR_EXECUTIVE_KEY = "goldstarExecutive";
const getImageUrl = (images, key) => {
  const imageData = images == null ? void 0 : images.find((item) => (item == null ? void 0 : item.image_key) === key);
  return imageData == null ? void 0 : imageData.image_picker[0].url;
};
const getMembershipCard = (membershipType, membershipTier, composableWindow) => {
  var _a;
  const cardImagesData = composableWindow.find(
    (item) => {
      var _a2;
      return ((_a2 = item == null ? void 0 : item.text_with_images) == null ? void 0 : _a2.development_key) === CARD_IMAGES_DEV_KEY;
    }
  );
  const images = (_a = cardImagesData == null ? void 0 : cardImagesData.text_with_images) == null ? void 0 : _a.image_inclusion;
  const isExecutive = membershipTier === "Executive";
  if (isExecutive) {
    return getImageUrl(images, GOLD_STAR_EXECUTIVE_KEY);
  }
  const isBusiness = [
    "Business",
    "Business Trial",
    "Complimentary Business"
  ].includes(membershipType);
  if (isBusiness) {
    return getImageUrl(images, BUSINESS_CARD_KEY);
  }
  return getImageUrl(images, GOLD_CARD_REGULAR_KEY);
};
const findBodyTextItemByDevFieldKey = (composableWindow, key) => {
  var _a, _b;
  const composableWindowItem = composableWindow.find(
    (item) => {
      var _a2, _b2;
      return ((_a2 = item == null ? void 0 : item.text_only) == null ? void 0 : _a2.development_field_key) === key || ((_b2 = item == null ? void 0 : item.text_with_images) == null ? void 0 : _b2.development_key) === key;
    }
  );
  return ((_a = composableWindowItem == null ? void 0 : composableWindowItem.text_only) == null ? void 0 : _a.body) || ((_b = composableWindowItem == null ? void 0 : composableWindowItem.text_with_images) == null ? void 0 : _b.body);
};
const statusMembershipTypeMap = {
  Ancillary: "typeGoldStar",
  Business: "typeBusiness",
  "Business Trial": "typeBusiness",
  "Complimentary Business": "typeBusiness",
  "Complimentary Gold Star": "typeGoldStar",
  Employee: "typeEmployee",
  "Gold Star": "typeGoldStar",
  "Gold Star Trial": "typeGoldStar",
  Internal: "typeEmployee"
};
const getMembershipCategory = ({
  membershipInfo,
  locale,
  statusMembershipType,
  membershipTier
}) => {
  if (!statusMembershipType) return void 0;
  const language = locale === "fr-ca" ? "fr" : "en";
  const membershipTypeCategory = membershipTier === "Executive" ? "tierExecutive" : statusMembershipTypeMap[statusMembershipType];
  return membershipInfo[language][membershipTypeCategory];
};
export {
  findBodyTextItemByDevFieldKey,
  getMembershipCard,
  getMembershipCategory
};
